import React from "react";
import { CoreComponent } from "../core/CoreComponent";
import { log, addData, Validator, getValue } from "../core/Util";
import { DBConstants, ErrorMsg } from "../core/Constants";
import { Apiserver } from "../core/Apiserver";
import { BannerBar } from "../core/MenuBar";

export class RegisterWithEmail extends CoreComponent {

  constructor() {
    super();
    this.state.showlogin = false
  }

  backtologin = () => {
    this.redirect(this.props, '/login')
  }
  handleButtonClick = () => {

    let error = {};
    Validator.checkEmailId(error, "email");

    if (Validator.dict_size(error) != 0) {
      this.setState({ error: error })
    } else {
      this.postdata()
    }
  }

  handleCancelButtonClick = () => {
    this.redirect(this.props, '/login')
  }

  async postdata() {

    let datain = {}

    datain[DBConstants.Email_ID] = getValue("email")
    datain[DBConstants.SIGNUP_LINK_TYPE] = DBConstants.SIGNUP_LINK

    this.showAnimation();
    let response = await Apiserver.postcall("send_signup_link", datain);
    this.closeAnimation();

    let error = {};
    if (!Validator.checkResponseData(response, error)) {
      if (error.backenderror == DBConstants.ACCOUNT_ALREADY_SETUP)
        this.setState({ error: error, showlogin: true });
      else
        this.setState({ error: error });
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      this.redirectWithMessageAndData(this.props, "/setuppwd", "We found your account !", datain)
    }
  }

  render() {
    return (
      <div className="d-flex flex-row m0 p0 hfull backimg justify-content-center">
        <div className="col col-lg-5 col-md-6 col-s-12 fs15 m20 mt30 p0 formborder justify-content-center mh500">
          <BannerBar />
          <div>
            <label htmlFor="username" className="row p0 m0 mt25 ml10 propertytitle form-label">
              Register
          </label>
          </div>
          <div className="mt20 ml10 mr10">
            {this.getMessagePanel()}

            <label htmlFor="username" className="form-label mt10">
              Please note, we can only register you if your email is present in our system.
            </label>
            <label htmlFor="username" className="form-label mt10">
              Your email will be automatically added into our system if you have enabled trustedroads.com protection while providing your personal data.
            </label>

            <label htmlFor="username" className="propertyname form-label mt10">
              Please enter your email:
            </label>
            {this.state.error.email && (
              <div className="alert alert-danger">{this.state.error.email}</div>
            )}
            <input
              className="form-control"
              id="email"
              size="5"
            />
          </div>
          <div className="d-flex flex-row hc vc mt20 ml10 mr10">
            {!this.state.showlogin ? (<button onClick={this.handleButtonClick} type="button" className=" btn btn-primary" >
              Setup my account
            </button>) : (<button onClick={this.backtologin} type="button" className=" btn btn-primary" >
              Back To Login
            </button>)}
            <button onClick={this.handleCancelButtonClick} type="button" className=" btn btn-primary ml10" >
              Cancel
          </button>
          </div>
        </div>
      </div>
    );
  }
}
